import ApiBase from './ApiBase';

class StoreApi {
  fetchAll() {
    return ApiBase.get('/stores');
  }
}

export default new StoreApi();